<template>
  <transition name="drop">
    <div v-if="$store.state.show.frame" class="fill flexy flex column container" style="position: relative; top: 0, right: 0, left: 0, bottom: 0; background: #777777; padding: 0px">
      <div class="sub-container fill" style="overflow: hidden;">
        <div class="flex between flexx p4 xs-font align-center fill" v-if="!showdefault">
          <i class="fas fa-times warn-text fa-2x" @click.prevent="$set($store.state.show.frame, appsrc, false)"></i>
          <code class="sm-input xs-font white" type="text">{{appsrc}}</code>
          <i class="fas fa-mobile-alt fa-2x update-text" @click.prevent="refr()"></i>
        </div>
        <div class="xs-font warn" v-if="appsrc && appsrc.length > 5 && $store.state.show.frame[appsrc] && appsrc.indexOf('https') !== 0">Appception needs a valid URL and only works with https.</div>
        <iframe v-if="showdefault || (!refresh && appsrc && appsrc.length > 5 && $store.state.show.frame[appsrc] && appsrc.indexOf('https') === 0)" id="appsrc" class="fill fill-h flexy container" sandbox="allow-scripts allow-popups allow-same-origin allow-forms allow-modals  allow-presentation" :src="appsrc"/>
      </div>
  </div>
  </transition>
</template>
<script>
import { setTimeout } from 'timers';
export default {
  data () {
    return {
      test: 'test',
      refresh: false
    }
  },
  methods: {
    refr () {
      this.$set(this.$store.state.show.frame, this.appsrc, false);
      setTimeout(()=>{
         this.$set(this.$store.state.show.frame, this.appsrc, true);
      }, 10)
    }
  },
  name: 'iiframe',
  props: {'appsrc': {type: String}, 'showdefault': {type: String}}
}
</script>